import { render, staticRenderFns } from "./WishCitiesPopup.vue?vue&type=template&id=0a4df872&scoped=true&"
import script from "./WishCitiesPopup.vue?vue&type=script&lang=js&"
export * from "./WishCitiesPopup.vue?vue&type=script&lang=js&"
import style0 from "./WishCitiesPopup.vue?vue&type=style&index=0&id=0a4df872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4df872",
  null
  
)

export default component.exports